import { createContext, type ReactElement } from 'react';

import { DataProvider } from '../DataProvider';
import { transformStores } from './transformStores';
import type { StoresContextValue } from './types';

export const StoresContext = createContext<StoresContextValue>({} as StoresContextValue);

export function StoresDataProvider({
  children,
  url = 'data/stores.json',
  load = true,
}: {
  children: ReactElement;
  url?: string;
  load: boolean;
}): ReactElement {
  return (
    <DataProvider url={url} DataContext={StoresContext} transformer={transformStores} load={load}>
      {children}
    </DataProvider>
  );
}
